import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=f97f3e3a&scoped=true&external"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97f3e3a",
  null
  
)

export default component.exports